import {
  AuthRoutes,
  getAuthRouteFromPathname,
} from '@xarvio/frontend-core-router/lib/AuthRoutes';
import healthyFieldsRegistrationBgSrc from './assets/healthy-fields-registration-bg.jpg';
import smartSprayerBgSrc from './assets/smart-sprayer-auth-bg.jpg';

type GetAuthBackgroundSrcArgs = {
  pathname: string;
  search: string;
  whitelabelAuthBgSrc?: string;
};

export const getAuthBackgroundSrc = ({
  pathname,
  search,
  whitelabelAuthBgSrc,
}: GetAuthBackgroundSrcArgs): string | undefined => {
  const authRoute = getAuthRouteFromPathname(pathname);
  const isSmartSprayerLanding = authRoute === AuthRoutes.SMART_SPRAYER_LANDING;
  const isSmartSprayerRegistration =
    authRoute === AuthRoutes.SMART_SPRAYER_REGISTRATION;
  const isRegistration =
    authRoute === AuthRoutes.REGISTRATION || isSmartSprayerRegistration;
  const isHealthyFieldsRegistration =
    isRegistration && Boolean(new URLSearchParams(search).get('isXarvioHf'));

  if (isSmartSprayerLanding) {
    return smartSprayerBgSrc;
  }

  if (isHealthyFieldsRegistration) {
    return healthyFieldsRegistrationBgSrc;
  }

  if (
    (authRoute === AuthRoutes.LOGIN ||
      authRoute === AuthRoutes.FORGOT_PASSWORD ||
      isRegistration) &&
    whitelabelAuthBgSrc
  ) {
    return whitelabelAuthBgSrc;
  }

  if (isSmartSprayerRegistration) {
    return smartSprayerBgSrc;
  }

  return undefined;
};
